// extracted by mini-css-extract-plugin
export default {"group":"components-general-currency-picker-group-module__group"};